import type React from 'react';
import { memo } from 'react';
import { UserRound } from '@music-vine/cadence/icons';
const _Account = (props: React.SVGProps<SVGSVGElement>) => <UserRound {...props} data-sentry-element="UserRound" data-sentry-component="_Account" data-sentry-source-file="Account.tsx" />;
const Account = memo(_Account);
export const AccountWithIconTag = ({
  className
}: {
  className?: string;
}) => <i data-sentry-component="AccountWithIconTag" data-sentry-source-file="Account.tsx">
    <Account className={className} data-sentry-element="Account" data-sentry-source-file="Account.tsx" />
  </i>;
export default Account;